angular.module('wbDirectives').directive 'signoutButton',

['$location', 'users', ($location, users) ->

  link: (scope, element, attrs) ->
    users.currentUser()
    element.bind 'click', ->
      users.signout
        success: -> window.location = '/'
]
